const initState = () => {
  return [];
}

const invoices = (state=initState(), action) => {
  switch (action.type) {

    case "INIT_INVOICES":
      return action.payload;

    default:
      return state;
  }
}

export default invoices;
